import { ChangeDetectionStrategy, Component, contentChildren } from '@angular/core';
import { SwipeableDirective } from './swipeable.directive';

/** `T` is the payload type forwarded to the top card's `swiped` output — see SwipeableDirective. */
@Component({
  selector: 'recrewt-swipe-card-wrapper',
  templateUrl: './swipe-card-wrapper.component.html',
  styleUrls: ['./swipe-card-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwipeCardWrapperComponent<T = any> {
  readonly cards = contentChildren<SwipeableDirective<T>>(SwipeableDirective);

  public like(data?: T): void {
    this.cards()[0]?.simulateSwipe(true, data ?? null);
  }

  public dislike(data?: T): void {
    this.cards()[0]?.simulateSwipe(false, data ?? null);
  }
}
